<template>
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z" stroke="#fff"
              stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2"/>
        <path d="M13 21V11l8 5-8 5z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    </svg>
</template>

<script>
export default {
    name: 'PlaySvg',
};
</script>
